import { useMemo, ReactNode } from 'react';

import { filterUndefined } from './filterUndefined';
import type {
  GenericItem,
  RenderGroupHeaderProps,
  RenderMenuItem,
} from '../types';

export type FilteredMenuPropsInput<TItem extends GenericItem> = {
  renderMenuItem?: RenderMenuItem<TItem>;
  renderGroupHeader?: (props: RenderGroupHeaderProps) => ReactNode;
  /**
   * The id of the element that labels the dropdown menu.
   */
  'aria-labelledby'?: string;
  renderNoAutocompleteResults?: () => ReactNode;
  enableSearchHighlight?: boolean;
  /** Custom max-height for the menu container in pixels. Defaults to 300. */
  menuHeight?: number;
};

export const useFilteredMenuProps = <TItem extends GenericItem>({
  renderMenuItem,
  renderGroupHeader,
  'aria-labelledby': ariaLabelledBy,
  renderNoAutocompleteResults,
  enableSearchHighlight,
  menuHeight,
}: FilteredMenuPropsInput<TItem>) => {
  return useMemo(
    () =>
      filterUndefined({
        renderMenuItem,
        renderGroupHeader,
        'aria-labelledby': ariaLabelledBy,
        renderNoAutocompleteResults,
        enableSearchHighlight,
        menuHeight,
      }),
    [
      renderMenuItem,
      renderGroupHeader,
      ariaLabelledBy,
      renderNoAutocompleteResults,
      enableSearchHighlight,
      menuHeight,
    ],
  );
};
